<template>
  <v-bottom-sheet
    v-model="isVisible"
    data-qa="popup_map_departure_address_container"
    @click:outside="handleCloseDepartureAddressPopup"
    @keydown.esc="handleCloseDepartureAddressPopup"
  >
    <div class="bg-gray-0">
      <div class="text-h6 py-6 pl-4">
        Откуда поедем?
      </div>
      <v-text-field
        id="departureAddressInput"
        v-model="departureAddress.text"
        label="Адрес отправления"
        append-icon="ui-icon-geo-detect"
        class="mx-4"
        color="text-secondary"
        :error-messages="errorMessage"
        outlined
        data-qa="popup_map_departure_address_text_input"
        @input="clearErrorMessagesAndDepartureCoords"
        @click:append="determinateCoords"
      />
      <div class="d-flex justify-end pb-4">
        <v-btn
          class="mr-2 px-2"
          text
          data-qa="popup_map_cancel_button"
          @click="handleCloseDepartureAddressPopup"
        >
          Отменить
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2 px-2 branding-btn branding-btn--primary"
          text
          data-qa="popup_map_plot_route_button"
          :disabled="Boolean(!departureAddress.text || errorMessage)"
          @click="handlePlotRouteButton"
        >
          Проложить маршрут
        </v-btn>
      </div>
    </div>
  </v-bottom-sheet>
</template>

<script>
import { PopupDepartureAddressLogic } from 'www/vue_components/common/PopupMap/mixins'

export default {
  name: 'PopupDepartureAddressMobile',
  mixins: [PopupDepartureAddressLogic],
}
</script>
